module.exports = __webpack_public_path__ + "static/media/Shape-8.92d2890b.png";